import { getYesNoLabel, yesNoOptions } from '@Constants/selectOptions';
import { ApiVehicle } from '@Model';
import { Column } from '@synqo/frontend-component-library';

export const vehicleColumns: Column<ApiVehicle>[] = [
    { name: 'shorthand', label: 'Suchcode' },
    { name: 'licence_plate', label: 'Kennzeichen' },
    { name: 'manufacturer', label: 'Hersteller' },
    {
        name: 'is_trailer',
        label: 'Ist Anhänger',
        filterVariant: 'select',
        filterOptions: yesNoOptions,
        renderCell: ({ cellData }) => getYesNoLabel(cellData as boolean),
    },
];
